import { render, staticRenderFns } from "./CommunityPage_Forums.vue?vue&type=template&id=6bf2588e&scoped=true&"
import script from "./CommunityPage_Forums.vue?vue&type=script&lang=js&"
export * from "./CommunityPage_Forums.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPage_Forums.vue?vue&type=style&index=0&id=6bf2588e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2588e",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
